const cardItems = [
  {
    title: '全职高手',
    author: '蝴蝶蓝',
    status: '已完结',
    genre: '电竞热血',
    desc: '荣耀之巅，叶修归来。从零开始重返职业联盟巅峰的电竞传奇故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cool%20esports%20gamer%20with%20silver%20hair%20holding%20a%20gaming%20mouse%2C%20cyberpunk%20style%20background%20with%20holographic%20screens%2C%20Chinese%20manhua%20art%2C%20dynamic%20lighting%20with%20blue%20and%20orange%20contrast%2C%20confident%20expression%2C%20clean%20composition%2C%20professional%20illustration&width=600&height=800&seq=card-01&orientation=portrait',
  },
  {
    title: '斗罗大陆',
    author: '唐家三少',
    status: '已完结',
    genre: '玄幻热血',
    desc: '唐三穿越斗罗大陆，觉醒双生武魂，一步步踏上封号斗罗的巅峰之路。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20young%20warrior%20with%20blue%20hair%20summoning%20a%20magical%20spirit%20ring%2C%20fantasy%20landscape%20with%20floating%20islands%2C%20Chinese%20manhua%20style%2C%20warm%20golden%20energy%20effects%2C%20heroic%20pose%2C%20epic%20composition%2C%20vibrant%20colors&width=600&height=800&seq=card-02&orientation=portrait',
  },
  {
    title: '魔道祖师',
    author: '墨香铜臭',
    status: '已完结',
    genre: '古风玄幻',
    desc: '魏无羡重生归来，与蓝忘机携手揭开十六年前的惊天阴谋。',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20elegant%20young%20man%20in%20flowing%20black%20and%20red%20traditional%20Chinese%20robes%20playing%20a%20flute%2C%20moonlit%20ancient%20Chinese%20palace%20background%2C%20Chinese%20manhua%20style%2C%20mysterious%20atmosphere%2C%20soft%20silver%20lighting%2C%20beautiful%20ink%20wash%20aesthetic&width=600&height=800&seq=card-03&orientation=portrait',
  },
  {
    title: '伍六七',
    author: '何小疯',
    status: '连载中',
    genre: '搞笑热血',
    desc: '失去记忆的刺客伍六七，用一把剪刀守护小鸡岛的爆笑热血日常。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20funny%20assassin%20with%20scissors%20in%20a%20hoodie%20striking%20a%20dramatic%20pose%2C%20colorful%20tropical%20island%20backdrop%2C%20Chinese%20animation%20style%2C%20bright%20and%20cheerful%20lighting%2C%20playful%20composition%2C%20bold%20outlines%2C%20warm%20and%20vibrant%20colors&width=600&height=800&seq=card-04&orientation=portrait',
  },
  {
    title: '大理寺日志',
    author: 'RC',
    status: '连载中',
    genre: '古风悬疑',
    desc: '白猫少卿李饼在大理寺中破解各种离奇案件，古风探案漫画力作。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20white%20cat%20official%20in%20traditional%20Chinese%20court%20attire%2C%20ancient%20Chinese%20government%20office%20setting%2C%20Chinese%20manhua%20style%2C%20warm%20candlelight%20atmosphere%2C%20intricate%20architectural%20details%2C%20subtle%20suspense%20mood%2C%20elegant%20composition&width=600&height=800&seq=card-05&orientation=portrait',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            高品质完结漫画完整版，下拉式畅读不翻页
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cardItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`${item.title}漫画封面`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.genre}
                  </span>
                  <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                    item.status === '已完结' ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.status}
                  </span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">作者：{item.author}</p>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}